import { Box } from '@mui/material';
import React from 'react';

function GrowerYieldTabPanel(props) {
  const { children, value, id } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== id}
      id={`yield-tabpanel-${id}`}
      style={{ minHeight: 0, height: '100%' }}
    >
      {value === id && <Box style={{ height: '100%' }}>{children}</Box>}
    </div>
  );
}

export default GrowerYieldTabPanel;
